// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cursorZoom[data-v-6c8293f0] {\n  cursor: -webkit-zoom-in;\n  cursor: zoom-in;\n}\n.deleteImgButton[data-v-6c8293f0] {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n}", ""]);
// Exports
module.exports = exports;
